export default __webpack_public_path__ + "summary99c2b8.png";